import { render, staticRenderFns } from "./UserDocument.vue?vue&type=template&id=1dfd3bfd&scoped=true"
import script from "./UserDocument.vue?vue&type=script&lang=js"
export * from "./UserDocument.vue?vue&type=script&lang=js"
import style0 from "./UserDocument.vue?vue&type=style&index=0&id=1dfd3bfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfd3bfd",
  null
  
)

export default component.exports